export interface CategoryOrderSettings {
  ids: string[];
  names: string[];
}

function toStringArray(value: unknown): string[] {
  return Array.isArray(value)
    ? value.filter((entry): entry is string => typeof entry === 'string' && entry.trim().length > 0)
    : [];
}

export function readCategoryOrderSettings(settings: Record<string, unknown> | null | undefined): CategoryOrderSettings {
  return {
    ids: toStringArray(settings?.category_order),
    names: toStringArray(settings?.category_order_names),
  };
}

function getOrderIndex(entry: { id?: string | null; name: string }, order: CategoryOrderSettings) {
  const idIndex = entry.id ? order.ids.indexOf(entry.id) : -1;
  if (idIndex !== -1) {
    return idIndex;
  }

  const legacyIdIndex = order.ids.indexOf(entry.name);
  if (legacyIdIndex !== -1) {
    return legacyIdIndex;
  }

  const nameIndex = order.names.indexOf(entry.name);
  if (nameIndex !== -1) {
    return nameIndex;
  }

  return Number.MAX_SAFE_INTEGER;
}

export function sortCategoriesByOrder<T extends { id?: string | null; name: string }>(
  items: T[],
  order: CategoryOrderSettings,
) {
  // No custom order saved → preserve insertion order (creation order from DB)
  if (order.ids.length === 0 && order.names.length === 0) return [...items];

  return [...items].sort((a, b) => {
    const ai = getOrderIndex(a, order);
    const bi = getOrderIndex(b, order);
    if (ai !== bi) return ai - bi;
    // Items not in the saved order keep their relative position
    return 0;
  });
}

export function sortCategoryNamesByOrder(names: string[], order: CategoryOrderSettings) {
  // No custom order saved → preserve insertion order
  if (order.ids.length === 0 && order.names.length === 0) return [...names];

  return [...names].sort((a, b) => {
    const ai = getOrderIndex({ name: a }, order);
    const bi = getOrderIndex({ name: b }, order);
    if (ai !== bi) return ai - bi;
    return 0;
  });
}
